/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2018 Adobe
 *  All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import { getLogger } from '../utils/SearchLogger';
import WebStorage from '../storage/WebStorage';
const PROFILES_STORAGE_KEY = 'cchome_profile';
export default class ProfileStorage {
	/**
	 * Get storage key for analytics
	 */
	static getProfileStorageKey() {
		return PROFILES_STORAGE_KEY;
	}

	/**
	 * This method stores the profile response object in session storage.
	 * @param {Object} profile profile object to be stored
	 */
	static writeProfilesResponseToSessionStorage(profile: Profile | null | undefined) {
		if (WebStorage.storageAvailable('sessionStorage') && profile) {
			sessionStorage.setItem(PROFILES_STORAGE_KEY, JSON.stringify(profile));
			getLogger().info('Profile Storage', 'Logged Search User Profile');
		}
	}

	/**
	 * This method returns the cached profile response object from session storage, if present. If not present, it returns an empty profile.
	 */
	static readProfilesResponseFromSessionStorage(): Profile | null | undefined {
		if (WebStorage.storageAvailable('sessionStorage')) {
			const cachedProfile = sessionStorage.getItem(PROFILES_STORAGE_KEY);

			if (cachedProfile) {
				try {
					return JSON.parse(cachedProfile);
				} catch (e) {
					return undefined;
				}
			}
		}

		return undefined;
	}

	/**
	 * This method removes the cached profile response object from session storage.
	 */
	static removeProfilesResponseFromSessionStorage() {
		if (WebStorage.storageAvailable('sessionStorage')) {
			sessionStorage.removeItem(PROFILES_STORAGE_KEY);
		}
	}
}
